var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.63623,
    y: 4.2218,
    width: 20,
    height: 2,
    rx: 1,
    transform: "rotate(45 5.63623 4.2218)",
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92912 19.071C5.31965 19.4616 5.95281 19.4616 6.34334 19.071L19.0713 6.34311C19.4618 5.95258 19.4618 5.31942 19.0713 4.9289C18.6807 4.53837 18.0476 4.53837 17.657 4.9289L4.92912 17.6568C4.5386 18.0473 4.5386 18.6805 4.92912 19.071Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoX);
export default __webpack_public_path__ + "static/media/ico-x.8203f8763e768bbf6dbb6eb3539dfcfb.svg";
export { ForwardRef as ReactComponent };